<div class="d-flex justify-content-end border-top flex-wrap">
  <span class="btn btn-sm">Actions:</span>
  @if (allowAssign && !allowHousekeeping && !allowStaff && !allowFrontDesk && !allowBar && !allowKiosk) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['assign']">Assign</a>
  } @else {
  @if (allowAssign || allowHousekeeping || allowStaff || allowFrontDesk || allowBar || allowKiosk) {
  <div ngbDropdown>
    <button class="btn btn-sm btn-link"
            ngbDropdownToggle>Assign</button>
    <div ngbDropdownMenu>
      @if (allowAssign) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['assign']">Room</a>
      }
      @if (allowHousekeeping) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['housekeeping']">Housekeeping</a>
      }
      @if (allowStaff) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['staff']">Staff</a>
      }
      @if (allowFrontDesk) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['frontdesk']">Front desk</a>
      }
      @if (allowBar) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['bar']">Bar</a>
      }
      @if (allowKiosk) {
      <a class="btn btn-sm btn-link"
         ngbDropdownItem
         [routerLink]="['kiosk']">Kiosk</a>
      }
    </div>
  </div>
  }
  }
  
  @if (allowSpare) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['spare']">Spare</a>
  }
  @if (allowUnassign) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['unassign']">Unassign</a>
  }
  @if (allowUnavailable) {
  <a class="btn btn-sm btn-link"
     [routerLink]="['unavailable']">Unavailable</a>
  }
  @if (notesEnabled) {
  <a class="btn btn-sm btn-link"
     (click)="openNotes()">Notes</a>
  }
  @if (assignmentHistoryEnabled) {
  <a class="btn btn-sm btn-link"
     (click)="openAssignmentHistory()">Assignment history</a>
  }
  <a [attr.href]="device | mdmLink"
     class="btn btn-sm btn-link"
     target="_blank"><span i18n>View in MDM </span>
    <fa-icon [icon]="['fas', 'external-link-alt']"></fa-icon>
  </a>
</div>